import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import moduleUser from './module/user.js'
import moduleAddress from './module/address.js'
import moduleCart from './module/cart.js'
import moduleApp from './module/app.js'
import moduleFahuo from './module/fahuo.js'
import moduleTrain from './module/train.js'

Vue.use(Vuex)

const store= new Vuex.Store({
    plugins: [createPersistedState()],
    modules: {
      user: moduleUser,
      address: moduleAddress,
      cart:moduleCart,
      app:moduleApp,
      fahuo:moduleFahuo,
      train:moduleTrain
    }
})
export default store
